import React, { useState, useEffect, useRef, useCallback } from 'react';
import Grid from '@mui/material/Grid2';

import { 
  Character,
  CharacterSpell,
  CharacterAction,
  CharacterAbility,
  CharacterSheetInterface,
  Attack,
  CharacterItem,
  Ability,
  StoredSpell,
  SpellsFromList,
  SpellsFromListWithCosts,
  CreatureAbility,
  CharacterFeature,
  // CharacterWeapon,
} from "@dndModels";

import DandDCharacterUtilities from "@dndUtilities/char_utilities";

import CharacterActionInput from "@dndComponents/character/spells_and_abilities/CharacterActionInput";

import ModalOrDrawer from "@components/display/ModalOrDrawer";
import CharacterSpellDetails from "@dndComponents/character/spells_and_abilities/CharacterSpellDetails";
import CharacterItemDetailsSidebar from "@dndComponents/character/inventory/item/CharacterItemDetailsSidebar";
import CharacterAttackSidebar from "@dndComponents/character/inventory/CharacterAttackSidebar";
import DisplayStringWithReplacementsRecursive from '@dndComponents/display/DisplayStringWithReplacementsRecursive';
import LoadingBox from '@components/input/LoadingBox';

interface Props {
  char_int: CharacterSheetInterface;
  char: Character;
  shared?: boolean;
}

// const api = API.getInstance();
// const common_util = DataUtilities.getInstance();
const char_util = DandDCharacterUtilities.getInstance();

export default function CharacterPassives({
  char_int,
  char,
  shared = false,
}: Props) {
  const [fetched, setFetched] = useState(false);
  const [real_reloading, setRealReloading] = useState(false);
  const [reloading, setReloading] = useState(false);
  const [reloading_costs, setReloadingCosts] = useState(false);
  
  const [drawer, setDrawer] = useState("");
  const [details_action, setDetailsAction] = useState<CharacterAction | CharacterFeature | null>(null);
  const mounted = useRef(false);

  useEffect(() => { 
    mounted.current = true;

    return () => {
      mounted.current = false;
    };
  }, []);

  const actionsChanged = useCallback(() => {
    setRealReloading(true);
  }, []);

  useEffect(() => {
    if (!fetched) {
      char_int.subscription_holder.subscribe("Recalculated", mounted, recalculated);
      char_int.subscription_holder.subscribe("Actions", mounted, actionsChanged);
      // console.log(id);
      setFetched(true);
    }
  }, [fetched]);

  const recalculated = () => {
    // console.log("Actions");
    setReloading(true);
  }
  
  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);
  
  useEffect(() => {
    if (real_reloading) {
      setRealReloading(false);
    }
  }, [real_reloading, setRealReloading]);
  
  useEffect(() => {
    if (reloading_costs) {
      setReloadingCosts(false);
    }
     
  }, [reloading_costs, setReloadingCosts]);

  const validAction = (o: CharacterAction) => {
    // if (o.name.includes("Find Famil")) {
    //   debugger;
    // }
    if (o.action instanceof Attack) {
      // return !character.unarmed_strike_customizations.hidden;
    } else {
      if (o.action instanceof CharacterSpell) {
        if (o.action.hidden) {
          return false;
        } else if (!o.lowest) {
          return o.action.show_upcasts.includes(o.level);
        } else if (o.ritual_only && o.action.hide_ritual) {
          return false;
        } else if (o.action.ritual) {
          return false;
        } else {
          return true;
        }
      } else if (o.action instanceof StoredSpell) {
        if (o.action.hidden) {
          return false;
        } else {
          return true;
        }
      } else if (o.action instanceof CharacterAbility) {
        if (o.action.ritual) {
          return false;
        } else if (o.action.the_ability instanceof SpellsFromList || 
          o.action.the_ability instanceof SpellsFromListWithCosts) {
          if (o.special_resource) {
            return !o.action.hide_special;
          } else if (!o.lowest) {
            return o.action.show_upcasts.includes(o.level);
          } else if (o.ritual_only && o.action.hide_ritual) {
            return false;
          } else if (o.action.hidden) {
            return false;
          } else {
            return true;
          }
        } else if (o.action.the_ability instanceof Ability) {
          if (o.special_resource) {
            return !o.action.hide_special;
          } else if (o.action.hidden) {
            return false;
          } else {
            return true;
          }
        } else if (o.action.hidden) {
          return false;
        } else if (o.action.the_ability instanceof CreatureAbility) {
          return true;
        } else {
          // console.log(o);
          return true;
        }
      } else {
        // console.log(o);
        return true;
      }
    }
    return true;
  }

  const renderActionGroup = () => {
    const log_it = false; // group === "Actions"; // group === "Bonus Actions"; // 
    if (char_int instanceof Character) {
      if (log_it) {
        console.log(char_int.actions); // .filter(o => o.name.includes("Drink"))
        debugger;
      }
      // let filtered = char.actions;
      let filtered = char_int.actions.filter(o => o.is_passive && validAction(o));
      filtered = filtered.filter(o => 
        !(o.action instanceof CharacterAbility) || 
        !(o.action.the_ability instanceof Ability) ||
        o.action.the_ability.show_in.includes("Actions"));
      // filtered = filtered.filter(o => o.name.includes("Unseen"));
      if (log_it) {
        console.log(char_int.actions);
        console.log(filtered);
        debugger;
      }
      if (filtered.length > 0) {
        return (
          <>
            <Grid
              style={{ 
                fontWeight: "bold", 
                fontSize: "12px"
              }}
              container
              spacing={0}
              direction="row"
              size={{
                xs: 12
              }}>
              <Grid
                className="centered"
                size={3}>Name</Grid>
              <Grid
                container
                spacing={0}
                direction="row"
                size={9}>
                <Grid
                  className="centered"
                  size={3}>Cost/When</Grid>
                <Grid
                  className="centered"
                  size={{
                    xs: 3
                  }}>Range/Area</Grid>
                <Grid
                  className="centered"
                  size={{
                    xs: 3
                  }}>Attack/DC</Grid>
                <Grid
                  className="centered"
                  size={{
                    xs: 3
                  }}>Effect</Grid>
              </Grid>
            </Grid>
            { renderActionsOfType(filtered) }
          </>
        );
      }
    } else {
      if (log_it) {
        console.log(char_int.actions); // .filter(o => o.name.includes("Drink"))
        debugger;
      }
      let filtered = [...char_int.actions.filter(o => o.is_passive && validAction(o)), ...char_int.traits.filter(o => validAction(o))];
      if (log_it) {
        console.log(char_int.actions);
        console.log(filtered);
        debugger;
      }
      if (filtered.length > 0) {
        return (
          <>
            <Grid
              style={{ 
                fontWeight: "bold", 
                fontSize: "12px"
              }}
              container
              spacing={0}
              direction="row"
              size={{
                xs: 12
              }}>
              <Grid
                className="centered"
                size={3}>Name</Grid>
              <Grid
                container
                spacing={0}
                direction="row"
                size={9}>
                <Grid
                  className="centered"
                  size={3}>Cost/When</Grid>
                <Grid
                  className="centered"
                  size={{
                    xs: 3
                  }}>Range/Area</Grid>
                <Grid
                  className="centered"
                  size={{
                    xs: 3
                  }}>Attack/DC</Grid>
                <Grid
                  className="centered"
                  size={{
                    xs: 3
                  }}>Effect</Grid>
              </Grid>
            </Grid>
            { renderActionsOfType(filtered) }
          </>
        );
      }
    }
  }

  const renderActionsOfType = (actions: CharacterAction[]) => {
    const log_it = false; // type === "Special"; // group === "Actions"; // 
    if (log_it) {
      console.log(actions);
      // actions = actions.filter(o => o.name.includes("Drink"));
      debugger;
    }
    return (
      <>
        { actions.map(action => {
          if (reloading) {
            return null;
          } else {
            return (
              <Grid size={12}
                key={`${action.true_id}_${action.type}_${action.level}_${action.slot}`}
                style={{ 
                  fontSize: "12px"
                }}>
                <CharacterActionInput
                  char_int={char_int}
                  char={char}
                  action={action}
                  shared={shared}
                  level={action.level}
                  // casting_time_cost
                  show_casting_time
                  onOpen={() => {
                    setDetailsAction(action);
                    setDrawer("details");
                  }}
                />
              </Grid>
            );
          }
        })}
      </>
    );
  }

  const renderExtras = () => {
    const action = details_action;
    const open = drawer === "details";
    if (open) {
      if (action instanceof CharacterAction) {
        // console.log(action);
        let char_item: CharacterItem | undefined = undefined;
        if (action.action instanceof CharacterItem) {
          char_item = action.action;
        } else if (char_int instanceof Character) {
          if (action.action instanceof CharacterAbility && action.action.item_id !== "") {
            const item_id = action.action.item_id;
            char_item = char_int.inventory.items.find(o => o.true_id === item_id);
          }
        }
        return (
          <>
            <ModalOrDrawer
              open={ drawer === "details" } 
              onClose={() => {
                setDrawer("");
                char_int.subscription_holder.modalClosed();
              }}>
              { char_item && char_int instanceof Character ? 
                <CharacterItemDetailsSidebar
                  char={char_int}
                  char_item={char_item}
                  action={action}
                  shared={shared}
                  onRemove={() => {
                    char_int.changed();
                    char_int.subscription_holder.resourcesChanged();
                    char_int.subscription_holder.recalculate();
                    setDrawer("");
                  }}
                /> 
              : (action.action instanceof CharacterSpell || 
                action.action instanceof CharacterAbility) ? 
                <CharacterSpellDetails
                  char_int={char_int}
                  obj={ action.action }
                  level={ action.level }
                  type={action.type}
                  action={action}
                  shared={shared}
                  onObjChange={(obj: CharacterSpell | CharacterAbility) => {
                    if (obj instanceof CharacterSpell) {
                      const spell_finder = char_int.mind.spells.filter(o => o.true_id === obj.true_id);
                      if (spell_finder.length === 1) {
                        const char_spell = spell_finder[0];
                        char_spell.copy(obj);
                        char_int.subscription_holder.recalculate();
                        char_int.changed();
                      } else {
                        console.error("Spell Find Error:");
                        console.error(obj);
                        console.error(spell_finder);
                        console.error(char_int.mind.spells);
                      }
                    } else {
                      let ability_finder = char_int.mind.abilities.filter(o => o.true_id === obj.true_id);
                      if (ability_finder.length === 0) {
                        ability_finder = char_int.mind.spell_as_abilities.filter(o => o.true_id === obj.true_id);
                      }
                      if (ability_finder.length === 1) {
                        const char_ability = ability_finder[0];
                        char_ability.copy(obj);
                        char_int.subscription_holder.recalculate();
                        char_int.changed();
                      } else {
                        console.error("Ability Find Error:");
                        console.error(obj);
                        console.error(ability_finder);
                        console.error(char_int.mind.abilities);
                      }
                    }
                  }}
                  onClose={() => {
                    setDrawer("");
                  }}
                /> 
              : action.action instanceof Attack && 
                <CharacterAttackSidebar
                  char={char_int}
                  attack={action.action}
                />
              }
            </ModalOrDrawer>
          </>
        );
      } else if (action instanceof CharacterFeature) {
        return (
          <>
            <ModalOrDrawer
              open={ drawer === "details" } 
              onClose={() => {
                setDrawer("");
              }}>
              <Grid container spacing={0} direction="row">
                <Grid size={12} className="header">{ action.name }</Grid>
                <Grid size={12}>
                  <DisplayStringWithReplacementsRecursive cfs={char_int} display_string={action.description} />
                </Grid>
              </Grid>
            </ModalOrDrawer>
          </>
        );
      }
    }
    return null;
  }

  if (real_reloading) {
    return (<LoadingBox />);
  }
  return (
    <Grid container spacing={0} direction="row" className="curved_border bg_black_transp">
      <Grid size={12} className="header centered">
        Passive Effects
      </Grid>
      { renderActionGroup() }
      { renderExtras() }
    </Grid>
  );
}
